/**
 * Puzzle Session - Shared Mutable State
 *
 * Singleton object holding the mutable puzzle session state shared across
 * all legacy facade modules. Replaces module-level `let` variables that
 * were previously in facade.ts.
 */

import type { Puzzle } from '../core/Puzzle';
import type { HistoryManager } from '../core/HistoryManager';
import type { CellEvents } from '../events/CellEvents';
import type { MainMenu } from '../ui/MainMenu';
import type { SolutionMenu } from '../ui/SolutionMenu';
import type { ClueMenu } from '../ui/ClueMenu';

export interface PuzzleSession {
    currentPuzzle: Puzzle | null;
    historyManager: HistoryManager | null;
    cellEvents: CellEvents | null;
    mainMenu: MainMenu | null;
    solutionMenu: SolutionMenu | null;
    clueMenu: ClueMenu | null;
    menuEventsAttached: boolean;
    dragState: {
        isDragging: boolean;
        dragElement: HTMLElement | null;
        startX: number;
        startY: number;
        offsetX: number;
        offsetY: number;
    };
}

export const session: PuzzleSession = {
    currentPuzzle: null,
    historyManager: null,
    cellEvents: null,
    mainMenu: null,
    solutionMenu: null,
    clueMenu: null,
    menuEventsAttached: false,
    dragState: {
        isDragging: false,
        dragElement: null,
        startX: 0,
        startY: 0,
        offsetX: 0,
        offsetY: 0,
    },
};
